import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FullFeedbackAlertType } from 'src/app/models/enums/full-feedback-alert-type';

export interface FullFeedbackAlertData {
  type: FullFeedbackAlertType;
  title: string;
  messages: string[];
  error_msg?: string[];
  confirm?: boolean;
  positive?: string;
  positiveIcon?: string;
  negative?: string;
  negativeIcon?: string;
  hideNegative?: boolean;
  requiredReason?: boolean;
  reasonTitle?: string;
  hasDate?: boolean;
  requiredDate?: boolean;
  dateLabel?: string;

  checkbox?: boolean;
  checkboxLabel?: string;
  optionalReason?: boolean;
  disableConfirm?: boolean;
  minDate?: Date;
  maxDate?: Date;
  onConfirm?: (value: any) => Promise<string[] | null | undefined>;
}

@Component({
  selector: 'app-full-feedback-alert',
  templateUrl: './full-feedback-alert.component.html',
  styleUrls: ['./full-feedback-alert.component.scss'],
})
export class FullFeedbackAlertComponent implements OnInit {
  descriprion: UntypedFormControl;
  check = new UntypedFormControl(false);
  dateControl = new UntypedFormControl(null);

  readonly TYPE = FullFeedbackAlertType;
  constructor(
    private dialogRef: MatDialogRef<FullFeedbackAlertComponent>,
    @Inject(MAT_DIALOG_DATA) public data: FullFeedbackAlertData,
  ) {
    this.descriprion = new UntypedFormControl(null, Validators.required);
    this.check = new UntypedFormControl(false);
    this.dateControl = new UntypedFormControl(
      null,
      this.data?.requiredDate ? Validators.required : [],
    );
  }

  ngOnInit(): void {
    if (this.data.optionalReason && !this.data.requiredReason) {
      this.descriprion.clearValidators();
      this.descriprion.updateValueAndValidity();
    }
    if (this.data.requiredDate) {
      this.dateControl.setValidators([Validators.required]);
      this.dateControl.updateValueAndValidity();
    } else {
      this.dateControl.clearValidators();
      this.dateControl.updateValueAndValidity();
    }
    this.initialize();
  }

  async initialize(): Promise<void> {
    this.dialogRef.addPanelClass([
      'animate__animated',
      'animate__slideInUp',
      'animate__faster',
    ]);
    await this.dialogRef.beforeClosed().toPromise();
    this.dialogRef.removePanelClass([
      'animate__animated',
      'animate__slideInUp',
      'animate__faster',
    ]);
    this.dialogRef.addPanelClass([
      'animate__animated',
      'animate__fadeOutDown',
      'animate__faster',
    ]);
  }

  isSubmitting = false;

  getConfirmValue(): any {
    if (
      this.data.requiredReason ||
      this.data.optionalReason ||
      this.data.hasDate ||
      this.data.requiredDate
    ) {
      if (this.data.hasDate || this.data.requiredDate) {
        return {
          reason: this.descriprion.value,
          date: this.dateControl.value,
        };
      }
      return this.descriprion.value;
    }
    return this.data.checkbox ? (this.check.value ? 2 : 1) : 2;
  }

  async onConfirmClick() {
    const val = this.getConfirmValue();
    if (this.data.onConfirm) {
      this.isSubmitting = true;
      try {
        const error_msg = await this.data.onConfirm(val);
        if (error_msg && error_msg.length > 0) {
          this.data.error_msg = error_msg;
          this.isSubmitting = false;
        } else {
          this.dialogRef.close(val);
        }
      } catch (err: any) {
        this.data.error_msg = [err || 'Error occurred'];
        this.isSubmitting = false;
      }
    } else {
      this.dialogRef.close(val);
    }
  }
}
